<template>
  <v-app>
    <v-app-bar 
      dark 
      color="pink accent-4"
    >
      <v-toolbar-title class="headline text-uppercase">
        <span>Britt</span>
        <span 
          class="font-weight-light"
        >
          Designs</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        text
        href="https://twitter.com/attackongamez"
        target="_blank"
      >
        <span class="mr-2">
          <v-icon>mdi-heart</v-icon>
          Follow Me
        </span>
      </v-btn>
    </v-app-bar>

    <v-content>
      <Header/>
      <v-spacer></v-spacer>
      <Works />
      <v-spacer></v-spacer>
      <ContactForm />
      <Footer />
    </v-content>
  </v-app>
</template>

<script>
import Header from './components/Header';
import Works from './components/Works';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';

export default {
  name: 'App',
  components: {
    Header,
    Works,
    ContactForm,
    Footer
  },
  data: () => ({
    //
  }),
  created() {
    this.$vuetify.theme = {
      "primary": "#e91e63",
      "secondary": "#424242",
      "accent": "#82B1FF",
      "error": "#FF5252",
      "info": "#2196F3",
      "success": "#4CAF50",
      "warning": "#FB8C00"

    }
  }
};
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Pacifico&display=swap');
</style> 